// @flow
/**
 * User: Mike Chung
 * Date: 4/3/2018
 * Time: 2:11 PM
 */
import type {SsoUserQueryCriteria} from "../model/sso/SsoUserQueryCriteria";
import SsoUser from "../model/sso/SsoUser";
import * as queryString from "query-string";
import * as _ from 'lodash';
import config from "../config/config";
import type {Caller} from "../components/QueryPage";

type SsoUserQueryResult = {
    "totalResult": number,
    "result": Array<SsoUser>
}


export async function findSsoUserByCriteria(criteria: SsoUserQueryCriteria, caller: Caller, auth: string): Promise<SsoUserQueryResult> {

    const request: any = {
        ...criteria,
        ...caller
    };

    let response = await fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/individuals?${queryString.stringify(request)}`, {
        headers: {
            "content-type": "text/plain",
            "Authorization": `Bearer ${auth}`
        }
    });

    if (response.status === 200) {

        let queryResult = await response.json();
        let result: SsoUserQueryResult = {
            totalResult: queryResult.totalResult,
            result: _.map(queryResult.result, (ssoUser) => {
                return new SsoUser(ssoUser.ssoUid, ssoUser.email, ssoUser.firstName, ssoUser.lastName,
                    ssoUser.status, ssoUser.createDate, ssoUser.modifyDate, ssoUser.companyName, ssoUser.countrySid, ssoUser.countryCode);
            })
        };
        return result;

    } else if (response.status === 403 || response.status === 401) {

        throw await response.json();

    } else if (response.status === 500) {

        throw {message: "Server Error"};

    } else if (response.status === 504) {

        throw await response.json();

    } else {
        throw new Error();
    }
}

export async function resendActivationEmail(ssoUid: string, caller: Caller, auth: string): Promise<any> {

    const obj: any = {
        ssoUid: ssoUid,
        ...caller
    };

    let response = await fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/individual/resend-confirmation-email`, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": `Bearer ${auth}`
        },
        body: JSON.stringify(obj)
    });

    if (response.status === 200) {
        return;

    } else if (response.status === 403 || response.status === 401) {

        throw await response.json();

    } else if (response.status === 500) {

        throw {message: "Server Error"};

    } else if (response.status === 504) {

        throw await response.json();


    } else {
        throw new Error();
    }
}


export async function sendForgotPasswordEmail(ssoUid: string, caller: Caller, auth: string): Promise<any> {

    const obj: any = {
        ssoUid: ssoUid,
        ...caller
    };

    let response = await fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/individual/forgot-password`, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": `Bearer ${auth}`
        },
        body: JSON.stringify(obj)
    });

    if (response.status === 200) {
        return;

    } else if (response.status === 403 || response.status === 401) {

        throw await response.json();

    } else if (response.status === 500) {

        throw {message: "Server Error"};

    } else if (response.status === 504) {

        throw await response.json();


    } else {
        throw new Error();
    }
}

export async function activateUser(ssoUid: string, caller: Caller, auth: string): Promise<any> {

    const obj: any = {
        ssoUid: ssoUid,
        ...caller
    };

    let response = await fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/individual/activate-individual`, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            "Authorization": `Bearer ${auth}`
        },
        body: JSON.stringify(obj)
    });

    if (response.status === 200) {
        return;

    } else if (response.status === 403 || response.status === 401) {

        throw await response.json();

    } else if (response.status === 500) {

        throw {message: "Server Error"};

    } else if (response.status === 504) {

        throw await response.json();


    } else {
        throw new Error();
    }
}


// WEBPACK FOOTER //
// ./src/dao/ssoUserDao.js